import React from 'react';
import { format, parseISO } from 'date-fns';
import { ja } from 'date-fns/locale/ja';
import EntranceExamInfo from './EntranceExamInfo';

// --- Data ---
const eventDates = [
  '2026-07-25T10:00:00',
  '2026-08-30T10:00:00',
  '2026-09-26T10:00:00',
  '2026-10-24T10:00:00',
  '2026-11-28T10:00:00',
  '2026-12-27T10:00:00'
];

const SchoolEventCard = () => {
  // 現在の日時を取得
  const now = new Date();
  // 1つでも未来（または今日）の日程があるか確認
  const hasUpcomingEvents = eventDates.some(dateStr => new Date(dateStr) >= now);

  return (
    <div className="bg-gray-50 py-12 md:py-20">
      <div className="max-w-4xl mx-auto px-4">
        <EntranceExamInfo />

        {/* --- School Information Session Card --- */}
        <div className="bg-white p-6 md:p-10 rounded-lg shadow-lg mb-8">
          <div className="animate-fade-in">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-red-900 tracking-widest">学校説明会・オープンキャンパス</h2>

            {hasUpcomingEvents ? (
              <div className="mt-6 text-lg w-fit mx-auto text-left">
                <p className="font-semibold">
                  日程:
                  {eventDates.map((dateStr, index) => {
                    const isPast = new Date(dateStr) < now;
                    return (
                      <React.Fragment key={dateStr}>
                        <span className={isPast ? 'line-through text-gray-400 px-1' : 'px-1'}>
                          {format(parseISO(dateStr), 'M月d日(E)', { locale: ja })}
                        </span>
                        {index < eventDates.length - 1 && '、'}
                      </React.Fragment>
                    );
                  })}
                </p>
                <p className="font-semibold mt-4">各日程ともに<span className='ps-3 text-3xl'>10:00～12:00</span></p>
                <p className="font-semibold mt-4">(説明会が1時間程度、その後希望者は個別相談)</p>
                {/* <p className="font-semibold mt-4">会場:土佐塾予備校本館3階(高知市はりまや町3丁目7-8)</p> */}
                {/* <p className="font-semibold mt-4">内容:通信制高校の説明、キャンパス紹介、個別相談</p> */}
                        <div className="text-center mt-10">
          <a
            href="/mail/openCampusMail.php"
            className="inline-block bg-red-700 hover:bg-red-800 text-white font-bold py-4 px-10 rounded-full shadow-xl transform hover:scale-105 transition-all duration-300 ease-in-out text-xl"
          >
            お申込みはこちら
          </a>
          
        </div>
              </div>
            ) : (
              <p className="mt-6 text-center text-gray-700">現在予定されている説明会はありません。日程が決まり次第、こちらでお知らせします。</p>
            )}
          </div>
        </div>

        {/* --- Nyuushi Consultation Card --- */}
        {/* <div className="bg-white p-6 md:p-10 rounded-lg shadow-lg mb-8">
          <div className="mt-6 text-lg w-fit mx-auto text-left ">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-red-900 tracking-widest mb-5">学校説明会(高校生対象)</h2>

            <p className="font-semibold">日程:令和7年12月27日(土)</p>


            <p className="font-semibold mt-4">時間:①10:30～12:00 ②14:00～15:30</p>


            <p className="font-semibold mt-4">会場:土佐塾予備校本館3階(高知市はりまや町3丁目7-8)</p>


            <p className="font-semibold mt-4">内容:通信制高校の説明、キャンパス紹介、個別相談</p>
          </div>
        </div> */}

        {/* --- Individual Consultation Card --- */}
        <div className="bg-white p-6 md:p-10 rounded-lg shadow-lg">
          <div className="animate-fade-in">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-red-900 tracking-widest">個別相談(中学生・高校生・保護者対象)</h2>
            {/* <p className="text-center text-xl text-gray-700 mt-1 font-bold ">※高校生対象</p> */}

            <div className="mt-6 text-lg text-center md:text-center">
              <div className="text-center w-3/4">
                <p className="leading-relaxed text-left">「通信制高校ってどんなとこ？」<br />
                「今学校に通えてないんですが…」<br />
                「学年の途中からでも転入できますか？」<br />
                など、今抱えている悩みや不安を解消するお手伝いをさせていただきます。<br />
                ゆっくりお話ししながら、些細な疑問や不安な点に個別でお答えいたします。
                </p>
              </div>
              <div className="mt-4 inline-block bg-gray-100 p-4 rounded-lg">
                <p class="text-left"><span className="font-semibold">日時:</span> 随時</p>
                <p><span className="font-semibold">時間:</span> ご希望の時間をご相談ください</p>
              </div>
                      <div className="text-center mt-10">
          <a
            href="https://www.daiichigakuin.ed.jp/inquiry/"
            className="inline-block bg-red-700 hover:bg-red-800 text-white font-bold py-4 px-10 rounded-full shadow-xl transform hover:scale-105 transition-all duration-300 ease-in-out text-xl"
          >
            お申込みはこちら
          </a>
          
        </div>
            </div>
          </div>
        </div>

        {/* --- Centered Call to Action --- */}

      </div>
      <style>{`
        .animate-fade-in {
          animation: fadeIn 0.5s ease-in-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default SchoolEventCard;